import styled from "styled-components"
import { VideoWrapperStyles } from "./full-width-video-styles"

interface VideoWrapperProps {
  width: number
  height: number
}

export const VideoWrapper = styled.div<VideoWrapperProps>`
  width: 100%;
  iframe {
    width: 100%;
    height: calc(100vw*(${props => props.height/props.width}));
  }
  ${VideoWrapperStyles}
`;
